import { render, staticRenderFns } from "./Raum.vue?vue&type=template&id=3261792a"
import script from "./Raum.vue?vue&type=script&lang=js"
export * from "./Raum.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports